import { AppMixinsOptions } from '../IMaterial';

export const initializeMixins = (config?: AppMixinsOptions): AppMixinsOptions => {
  return {
    ...config,
  };
};
